var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission-denied"},[_c('h1',[_vm._v("401 - 权限不足")]),_c('p',[_vm._v("抱歉，您没有访问该页面的权限。")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }